import type { PatientRelation } from '~/constants/patient/relations'

export type { PatientRelation }

export interface PatientMemberPublic {
  id: string
  accountId: string
  firstName: string
  lastName: string
  fullName: string
  phone: string
  nationalId: string | null
  relation: PatientRelation
}

export interface PatientMemberSummary {
  fullName: string
  relation: PatientRelation
}

export interface PatientAccountPublic {
  id: string
  phone: string
  birthDate: string | null
  gender: string | null
  members: PatientMemberPublic[]
}

export interface PatientProfilePublic extends PatientMemberPublic {
  canEditName: true
}

export interface PatientPortalHome {
  patient: PatientMemberPublic
  account: PatientAccountPublic
  siteTitle: string
  pendingFormCount: number
  nextAppointmentAt: string | null
  patientBaseAccess: 'none' | 'view' | 'edit'
  patientCanEditBase: boolean
  unreadChatCount: number
  activeVisitId: string | null
}

export const RELATION_REQUIRED_CODE = 'relation_required'

export interface RelationRequiredPayload {
  code: typeof RELATION_REQUIRED_CODE
  members: PatientMemberSummary[]
}
